export default __webpack_public_path__ + "static/media/cs-a018-7.454567ad.svg";